import React from 'react';
import {
  LTAccordionWrapper,
  LTTag,
  LTText
} from '@lambdatestincprivate/lt-components';
import { useTheme } from 'styled-components';
import ErrorRepetitionTimeline from './ErrorRepetitionTimeline';
import ErrorTrendChart from './ErrorTrendChart';
import ChevronRightStrokeIcon from '../../assets/ChevronRightStrokeIcon';
import BugIcon from '../../assets/BugIcon';
import styles from './AIRca.module.css';

const RCAErrorAnalytics = ({
  errorRepetitionData,
  errorTrendsData,
  rcaData,
  baseUrl,
}) => {
  const theme = useTheme();
  const analysisPoints = rcaData?.analysis ?? [];
  const hasRepetitionData = Array.isArray(errorRepetitionData);
  const hasTrendsData = Array.isArray(errorTrendsData);

  return (
    <div className={styles.analyticsContainer}>
      <BugIcon style={{ marginTop: '2px' }} />
      <div className={styles.contentColumn}>
        <div className={styles.topRow}>
          <div className={styles.categoryInfo}>
            <div className={styles.tagRow}>
              <LTTag
                customStyle={{
                  backgroundColor: '#CF222E',
                  color: '#FFFFFF',
                  borderWidth: 0,
                  borderColor: 'none'
                }}
                text={rcaData?.parent_failure_category}
                variant={LTTag.Variant.DANGER}
              />
              {rcaData?.root_cause_category && (
                <>
                  <ChevronRightStrokeIcon />
                  <LTTag
                    text={rcaData.root_cause_category}
                    variant={LTTag.Variant.DANGER}
                    textLength={50}
                  />
                </>
              )}
            </div>
            <LTText variant={LTText.TextVariant.SUBHEADER_BOLD}>
              {rcaData?.error_message || rcaData?.failure_summary}
            </LTText>
          </div>
          {hasRepetitionData && (
            <div className={styles.chartColumn}>
              <ErrorRepetitionTimeline
                errorRepetitionData={errorRepetitionData}
                category={rcaData?.root_cause_category}
                baseUrl={baseUrl}
              />
            </div>
          )}
        </div>
        <div className={styles.accordionWrapper}>
          <LTAccordionWrapper
            options={[
              {
                title: 'Detailed Analysis',
                childSectionComponent: (
                  <div className={styles.analysisContent}>
                    <ol className={styles.analysisList}>
                      {analysisPoints.map((point, index) => (
                        <li key={index} className={styles.analysisItem}>
                          <span className={styles.bullet} />
                          <LTText
                            variant={LTText.TextVariant.SUBHEADER_REGULAR}
                            color="text.default"
                          >
                            {point}
                          </LTText>
                        </li>
                      ))}
                    </ol>
                    {hasTrendsData && (
                      <ErrorTrendChart errorTrendsData={errorTrendsData} />
                    )}
                  </div>
                )
              }
            ]}
            headerExtraStyle={{
              border: 'none',
              background: 'none',
              padding: '0',
              height: 'fit-content'
            }}
            titleExtraStyle={{
              fontSize: '14px',
              fontWeight: '600',
              color: theme?.colors?.text?.muted
            }}
            childExtraStyle={{
              border: 'none',
              padding: '0 0  0 2px'
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default RCAErrorAnalytics;
